global.BACKGROUND_COLOR = "#312F2F"
global.SECONDARY_BACKGROUND_COLOR = "#F7F7F2"
global.TEXT_COLOR = "#FFFFFF"
global.SECOND_TEXT_COLOR = "#C5D86D"
global.THIRD_TEXT_COLOR = "#312F2F"
global.BUTTON_COLOR = "#F05D23"
global.BUTTON_TEXT_COLOR = "#FFFFFF"
global.BACKDROP_COLOR = "#000000"
global.FADE_DELAY = "500ms"
global.MIN_SCREEN_SIZE = 450